import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class BetaToggleHelper extends Helper {
  @service betaToggle;

  compute([key]) {
    return this.betaToggle[key];
  }
}
